/* global axios */
// Escopo de visibilidade do SUPERVISOR por TIME (backend: /supervisor_scope).
//   directInboxIds: caixas onde e colaborador DIRETO -> regra antiga (ve leads
//   de qualquer agente/supervisor); nas demais (via time) so ve leads de
//   colegas de time (teamMateIds).
// Cache em memoria carregado no boot da tela de conversas (ConversationView).
// Enquanto nao carregar, o filtro de tempo real do supervisor fica RESTRITIVO
// (nao mostra nada novo) para nunca vazar lead de outro time; a listagem REST
// ja vem filtrada do backend e nao depende deste cache.
let scope = null;

export const loadSupervisorScope = async accountId => {
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${accountId}/supervisor_scope`
    );
    scope = {
      directInboxIds: data.direct_inbox_ids || [],
      teamMateIds: data.team_mate_ids || [],
    };
  } catch (error) {
    // Mantem o cache anterior (ou null = restritivo).
  }
  return scope;
};

export const getSupervisorScope = () => scope;
